import { Component } from '@angular/core';

@Component({
	selector: 'app-timetable-map',
	templateUrl: './timetable-map.component.html',
	styleUrls: ['./timetable-map.component.css'],
})
export class TimetableMapComponent {
	constructor() {}
}
